import { render, staticRenderFns } from "./person-selector.vue?vue&type=template&id=9698cbe0"
import script from "./person-selector.vue?vue&type=script&lang=ts"
export * from "./person-selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports